import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Fade } from '@mui/material';

type Props = {
    children: React.ReactNode;
};

// ルート遷移時にコンテンツをフェード＋微小な上スライドで再表示するラッパ。
// pathname を key にした再 mount で MUI Fade を appear させるだけの「表示の被せ替え」で、
// route 解決やデータ取得のタイミングは変えない（遷移先 component の mount/fetch は従来通り 1 回）。
// reduced-motion 時は theme(MuiCssBaseline) の global で transition/animation が実質無効化され即時表示になる。
export const RouteFade: React.FC<Props> = ({ children }) => {
    const { pathname } = useLocation();
    return (
        <Fade key={pathname} in appear timeout={260}>
            <Box
                sx={{
                    '@keyframes routeFadeRise': {
                        from: { transform: 'translateY(6px)' },
                        to: { transform: 'translateY(0)' },
                    },
                    animation: 'routeFadeRise 260ms cubic-bezier(0, 0, 0.2, 1)',
                }}
            >
                {children}
            </Box>
        </Fade>
    );
};
